import { HiShieldCheck } from "react-icons/hi";
import { MdCancel, MdAnalytics } from "react-icons/md";
const data = [
  {
    icon: <HiShieldCheck/>,
    heading: "All You Need to know about us",
    detail:
      "Our hostel offers unlimited Wi-Fi, hygienic meals with optional Jain food, and rooms with attached washrooms. Nearly all rooms feature spacious balconies and are fully furnished. Enjoy our fully ventilated premises and water coolers providing fresh, cold water.",
  },
  {
    icon: <MdCancel />,
    heading: "House Rules",
    detail:
      "Our hostel fosters a respectful and peaceful environment with the following basic house rules: quiet hours from 10 PM to 6 AM, no smoking, alcohol, or parties on the premises, and no pets allowed. Guests must be signed in and cannot stay overnight. Residents should keep their rooms clean, promptly report maintenance issues, and respect shared spaces and property to ensure a comfortable living experience for all.",
  },
  {
    icon: <MdAnalytics />,
    heading: "Location Advantages",
    detail:
      "Our hostel boasts a prime location, just a 5-minute walk from both JECRC University and Poornima University, making it ideal for students. Nestled near Mahal Road, it offers easy access to various local amenities. The bustling market nearby provides convenient shopping options, ensuring you have everything you need within reach.",
  },
];
export default data;